import { render, staticRenderFns } from "./reSetPassword.vue?vue&type=template&id=20db0918&scoped=true"
import script from "./reSetPassword.vue?vue&type=script&lang=js"
export * from "./reSetPassword.vue?vue&type=script&lang=js"
import style0 from "./reSetPassword.vue?vue&type=style&index=0&id=20db0918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db0918",
  null
  
)

export default component.exports